module.exports = __webpack_public_path__ + "img/f6.ad394692.jpg";